import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { IWebContentData, WebContentDataApi } from './web-content-data.api';
import { Logger } from '../monitoring/logger/logger';
import { finalize, tap } from 'rxjs/operators';


@Injectable()
export class WebContentDataService {
  public webContentDataStore: Observable<IWebContentData>;

  public isLoading = false;
  public onLoadingChanged: Observable<boolean>;

  private _onLoadingChanged: BehaviorSubject<boolean>;
  private _webContentDataStore: BehaviorSubject<IWebContentData>;

  constructor(private webContentDataApi: WebContentDataApi,
    private logger: Logger) {

    this._webContentDataStore = new BehaviorSubject<IWebContentData>(null);
    this.webContentDataStore = this._webContentDataStore.asObservable();

    this._onLoadingChanged = new BehaviorSubject<boolean>(this.isLoading);
    this.onLoadingChanged = this._onLoadingChanged.asObservable();
  }

  getWebContentData() {
    this.isLoading = true;
    this._onLoadingChanged.next(this.isLoading);

    return this.webContentDataApi.getWebContentData()
      .pipe(
        tap((webContentData: IWebContentData) => {
          this.logger.debug('WebContentDataService: got the web content data');

          this._webContentDataStore.next(webContentData);
        }),
        finalize(() => {
          this.isLoading = false;
          this._onLoadingChanged.next(this.isLoading);
        }));
  }
}
